import React from 'react';
import { Table } from '@mui/material';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { MobileCard } from './MobileCard';
import { SWIPE_ANIMATIONS, SwipeableRow } from './SwipeableRow';

const ResponsiveTable = ({
    data = [],
    mobile,
    swipeAction = null,
    secondarySwipeAction = null,
    onClick,
    keyField = '_id',
    children,
    ...props
}) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    if (!isSmall) {
        return (
            <Table {...props}>
                {children}
            </Table>
        );
    }

    return (
        <Box>
            {data.map((record) => (
                <SwipeableRow
                    key={record[keyField]}
                    action={
                        swipeAction && (swipeAction.condition ? swipeAction.condition(record) : true)
                            ? {
                                  icon:
                                      typeof swipeAction.icon === 'function'
                                          ? swipeAction.icon(record)
                                          : swipeAction.icon,

                                  onSwipe: () =>
                                      swipeAction.onClick(record),

                                  swipeEnabled:
                                      swipeAction.condition
                                          ? swipeAction.condition(record)
                                          : true,

                                  animation:
                                      swipeAction.animation ||
                                      SWIPE_ANIMATIONS.remove,

                                  confirmation: {
                                      confirm:
                                          swipeAction.confirmation?.confirm ||
                                          false,
                                      message:
                                          swipeAction.confirmation?.message ||
                                          '',
                                  },
                              }
                            : null
                    }

                    secondaryAction={
                        secondarySwipeAction && (secondarySwipeAction.condition ? secondarySwipeAction.condition(record) : true)
                        ? {
                              icon:
                                  typeof secondarySwipeAction.icon === 'function'
                                      ? secondarySwipeAction.icon(record)
                                      : secondarySwipeAction.icon,

                              onSwipe: () =>
                                  secondarySwipeAction.onClick(record),

                              swipeEnabled:
                                  secondarySwipeAction.condition
                                      ? secondarySwipeAction.condition(record)
                                      : true,

                              animation:
                                  secondarySwipeAction.animation ||
                                  SWIPE_ANIMATIONS.remove,

                              confirmation: {
                                  confirm:
                                      secondarySwipeAction.confirmation?.confirm ||
                                      false,
                                  message:
                                      secondarySwipeAction.confirmation?.message ||
                                      '',
                              },
                          }
                        : null
                    }
                >
                    <MobileCard
                        record={record}
                        config={mobile}
                        onClick={() => onClick?.(record)}
                    />
                </SwipeableRow>
            ))}
        </Box>
    );
};

export default ResponsiveTable;